// src/components/MecaProductionReport/MecaProductionReport.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './MecaProductionReport.css';

function MecaProductionReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState('desc'); // Manejar orden asc/desc
  const [sortCriteria, setSortCriteria] = useState('name'); // Criterio de orden

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('http://192.168.0.126:5000/production/employee-meca');
        setData(response.data);
      } catch (err) {
        console.error('Error al obtener los datos:', err);
        setError('Error al obtener los datos.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const sortData = (criteria) => {
    const sortedData = [...data].sort((a, b) => {
      if (criteria === 'total_palets') {
        return sortOrder === 'desc' ? b.MaquinasPreparadas - a.MaquinasPreparadas : a.MaquinasPreparadas - b.MaquinasPreparadas;
      } else if (criteria === 'total_amount') {
        return sortOrder === 'desc' ? b.MantenimientosRealizados - a.MantenimientosRealizados : a.MantenimientosRealizados - b.MantenimientosRealizados;
      } else if (criteria === 'name') {
        return sortOrder === 'desc'
          ? b.name.localeCompare(a.name)
          : a.name.localeCompare(b.name);
      }
      return 0;
    });

    setData(sortedData);
    setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
    setSortCriteria(criteria);
  };

  if (loading) return <p className="loading">Cargando datos...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="container">
      <div className="controls">
        <h4 className="view-text">MECÁNICOS</h4>
      </div>

      <table className="responsive-table">
        <thead>
          <tr>
            <th onClick={() => sortData('name')} style={{ cursor: 'pointer', userSelect: 'none' }}>
              EMPLEADO {sortOrder === 'desc' && sortCriteria === 'name' ? '↓' : '↑'}
            </th>
            <th onClick={() => sortData('total_palets')} style={{ cursor: 'pointer', userSelect: 'none' }}>
              MAQUINAS PREPARADAS {sortOrder === 'desc' && sortCriteria === 'total_palets' ? '↓' : '↑'}
            </th>
            <th onClick={() => sortData('total_amount')} style={{ cursor: 'pointer', userSelect: 'none' }}>
              MANTENIMIENTOS REALIZADOS {sortOrder === 'desc' && sortCriteria === 'total_amount' ? '↓' : '↑'}
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className={
                index < 5
                  ? sortOrder === 'asc'
                    ? 'gold-row' // Sombrea las cinco primeras filas de oro si es ascendente
                    : 'bronze-row' // Sombrea las cinco primeras filas de bronce si es descendente
                  : '' // No aplica estilo especial al resto
              }
            >
              <td>{row.name}</td>
              <td
                className={
                  sortCriteria === 'total_palets'
                    ? 'gold-col'
                    : ''
                }
              >
                {row.MaquinasPreparadas}
              </td>
              <td
                className={
                  sortCriteria === 'total_amount'
                    ? 'gold-col'
                    : ''
                }
              >
                {row.MantenimientosRealizados}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MecaProductionReport;
